import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col items-center w-full text-7xl text-black pb-2" }, "Laurie's books", -1)
const _hoisted_2 = { class: "flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_landing_good_girl_karma = _resolveComponent("landing-good-girl-karma")
  const _component_landing_treasures_gift = _resolveComponent("landing-treasures-gift")
  const _component_landing_body = _resolveComponent("landing-body")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_landing_good_girl_karma),
      _createVNode(_component_landing_treasures_gift)
    ]),
    _createVNode(_component_landing_body)
  ]))
}